export default function SaveError(props: {}) {
  return (
    <div className="row my-5">
      <div className="col-sm-12">
        <div className="alert alert-danger" role="alert">
          <div className="mb-3">
            <h2>
              <i className="bi bi-exclamation-octagon-fill text-danger me-2"></i>{" "}
              Nie udało się zarejestrować konta
            </h2>
          </div>
          <div>
            <p>W trakcie rejestracji konta wystąpił błąd.</p>
            <p>
              Zamknij okno przeglądarki, otwórz witrynę ponownie i spróbuj się
              ponownie zarejestrować.
            </p>
            <p>
              Jeśli błąd będzie się powtarzał, skontaktuj się z administratorem
              systemu.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
